import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import './EventsMultiStateSwitch.scss';

const EventsMultiStateSwitch = (props) => {
  const { onChangeValue, filterData } = props;

  const [activeRadio, setActiveRadio] = useState(0);
  const [firstRadio, setFirstRadio] = useState(true);

  const setElementValue = (elementId, value) => {
    setFirstRadio(false);
    const radioElement = document.getElementById(elementId);
    const dataId = radioElement?.getAttribute('data-i');
    if (dataId) {
      setActiveRadio(Number(dataId));
      document.getElementById('radio_wrap').setAttribute('style', `--i:${dataId}`);
    }
    onChangeValue(value);
  };

  const labels = filterData?.filter((labelItem) => labelItem.type === 'events');

  const renderElements = () => labels[0]?.data?.map(({ value, label }) => (
    <>
      <input
        {...(value === activeRadio) ? { checked: true } : {}}
        type="radio"
        className={cx('EventsMultiStateSwitch__radio', {
          active: firstRadio,
        })}
        id={`radio-${value}`}
        key={`radio-${value}`}
        name="radioEle"
        data-i={value}
        onChange={() => setElementValue(`radio-${value}`, value)}
      />
      <label
        className="EventsMultiStateSwitch__label"
        htmlFor={`radio-${value}`}
        id={`label-${value}`}
        key={`label-${value}`}
      >
        <span>{label}</span>
      </label>
    </>
  ));

  return (
    <div className="EventsMultiStateSwitch">
      <fieldset
        className="EventsMultiStateSwitch__radio_wrap"
        id="radio_wrap"
      >
        {renderElements()}
      </fieldset>
    </div>
  );
};

EventsMultiStateSwitch.propTypes = {
  filterData: PropTypes.arrayOf(PropTypes.shape({
    type: PropTypes.string.isRequired,
    data: PropTypes.arrayOf(),
  }).isRequired).isRequired,
  onChangeValue: PropTypes.func.isRequired,
};

export default EventsMultiStateSwitch;
